import { Routes } from '@angular/router';
import { AuthGuard } from '../auth.guard';

export const monitorAlarmTabletRoutes: Routes = [
    {
        path: 'monitor/alarmtablet',
        loadComponent: () => import('./monitor-alarmtablet.component').then(m => m.MonitorAlarmTabletComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path:'',
                canActivate: [AuthGuard],
                loadComponent: () => import('./alarmtablet-dashboard/alarmtablet-dashboard.component').then(m => m.AlarmTabletDashboardComponent)
            },
            {
                path:'setting',
                canActivate: [AuthGuard],
                loadComponent: () => import('./alarmtablet-dashboard-setting/alarmtablet-dashboard-setting.component').then(m => m.MonitorAlarmTabletDashboardSettingComponent)
            },
            {
                path:'change-password',
                canActivate: [AuthGuard],
                loadComponent: () => import('../monitor/user/change-password/change-password.component').then(m => m.MonitorChangePasswordComponent)
            }
        ]
    }
];
